const apikey = process.env.VUE_APP_API_KEY || 'sgehtdt4g3srthvjyufvrbyrb68i'

export default apikey
